var component = require('../../../lib/js/component.js');
var requestInfo = require('../../../lib/js/request-info.js');
var utils = require('../../../lib/js/utils.js');

var ResponsiveMedia = require('../responsive-media/responsive-media.js');

function CarouselV2() {
    var component;

    var navIconLeft = "icon-arrow-left",
        navIconRight = "icon-arrow-right";

    var navText = [
        '<span class="sr-only">Previous</span><i class="' + navIconLeft + '"></i>',
        '<span class="sr-only">Next</span><i class="' + navIconRight + '"></i>'
    ];

    var _options = {
        dots: false,
        items: 1,
        loop: true,
        nav: true,
        navElement: 'button data-analytics-cta="Photo Scrolled"',
        navSpeed: 300,
        navText: navText,
        pullDrag: false,
        onInitialized: onCarouselInitialized,
        onRefreshed: onCarouselRefreshed,
        onTranslated: onCarouselTranslated
    };

    $(document).on('click', '.owl-prev, .owl-next, .Carousel-v2 .Share-icon, .Carousel-v2 .PinterestLink', function (event) {
        event.stopPropagation();
    });

    $(document).on('click', '.Carousel-v2 .lead-form-submit, .dual-lead-form-submit', function (e) {
        handleLeadFormSubmit(e);
        $("#communitySpecificForm input[name=CommunityId]").val(0);
        requestInfo.initRequestInfoModals();
    });

    var _triggerResizeEvent = utils.debounce(function () {
        window.dispatchEvent(new Event('resize')); // This is called to force the Carousel to recalculate its visible dimensions.
    }, 250, false);

    this.initialize = function (element, options) {
        var _this = this;
        component = this;
        _this.slidesAreLoaded = false;

        this.carouselGuid = utils.generateGuid();
        this.$element.attr("id", "Carousel-V2-" + this.carouselGuid);
        this.$element.attr("data-guid", this.carouselGuid);

        // Load all images in carousel and related slide show on any interaction
        this.$element.on('changed.owl.carousel', function (event) {
            component.handleChangedOwlCarousel(_this, event);
        });

        // Initialize carousel
        this.$element.find(".Carousel").owlCarousel(_options);

        // Initialize lead form
        this.initializeLeadForm(this.$element);

        this.on('keyup', function (e) {
            if (e.which == 9) {
                var cloneItems = this.$element.find('.owl-item.cloned:not(.active) button.Social-btn, .owl-item.cloned:not(.active) button.Share-icon');
                $.each(cloneItems, function (index, item) {
                    $(item).attr('tabindex', -1);
                });
            }
        });

        // Add event listener when CTA is clicked
        var id = "#Carousel-V2-" + this.carouselGuid;
        component.on('click', id + ' .Carousel-cta', this.onCarouselCtaClicked);
        this.$element.find('.owl-nav .owl-prev').attr('data-analytics-cta', 'Photo Scrolled');
        this.$element.find('.owl-nav .owl-next').attr('data-analytics-cta', 'Photo Scrolled');
    }

    function handleLeadFormSubmit(event) {
        var $leadFormSlide = $(event.currentTarget).closest('.LeadFormSlide');
        var $firstNameField = $leadFormSlide.find('input[name=FirstName');
        var $lastNameField = $leadFormSlide.find('input[name=LastName');
        var $emailField = $leadFormSlide.find('input[name=Email');
        var $zipCodeField = $leadFormSlide.find('input[name=ZipCode');
        var $phoneNumberField = $leadFormSlide.find('input[name=Phone');
        var $communityModalLeadForm = $(".CommunityModalLeadForm form[name=CommunityLeadForm]");

        $communityModalLeadForm.find('input[name=FirstName').val($firstNameField.val());
        $communityModalLeadForm.find('input[name=LastName').val($lastNameField.val());
        $communityModalLeadForm.find('input[name=Email').val($emailField.val());
        $communityModalLeadForm.find('input[name=ZipCode').val($zipCodeField.val());
        $communityModalLeadForm.find('input[name=Phone').val($phoneNumberField.val());
    }

    function onCarouselInitialized(event) {
        _triggerResizeEvent();
        component.disableSingleImageCarouselSwipe();
    }

    function onCarouselRefreshed(event) {
        var $thisCarousel = $(event.currentTarget).parent(".Carousel-v2");
        component.updateSelectableItems($thisCarousel);
    }

    function onCarouselTranslated(event) {
        event.preventDefault();

        var $thisCarousel = $(event.currentTarget).parent(".Carousel-v2");
        var $leadFormPhoneFields = $thisCarousel.find('.LeadFormSlide input[name=Phone]');
        var $uninitializedLeadFormPhoneFields = $leadFormPhoneFields.filter(function () {
            return !$(this).data('leadFormInitialized');
        });

        var $activeOwlItem = $thisCarousel.find('.owl-item.active');
        if ($activeOwlItem.length) {
            var $activeImageWrapper = $activeOwlItem.find('.image-wrapper');
            if ($activeImageWrapper.length) {
                $activeImageWrapper.removeAttr('tabindex');
            }
        }


        component.updateSelectableItems($thisCarousel);
        // Initialize lead form only once per phone field to avoid duplicate event bindings
        if ($uninitializedLeadFormPhoneFields.length) {
            component.initializeLeadForm($thisCarousel);
            $leadFormPhoneFields.data('leadFormInitialized', true);
        }
    }

    this.onCarouselCtaClicked = function (event) {
        var deeplinkId = $(this).data("deeplinkid");
        if (deeplinkId) {
            deeplinkId = deeplinkId.toString().trim('#');

            var element = document.getElementById(deeplinkId);
            if (element) {
                var boundingClientRect = element.getBoundingClientRect();
                var offset = 100;
                var calculatedTop = boundingClientRect.top + window.scrollY - offset;
                var currentTop = calculatedTop;
                var left = boundingClientRect.left

                // Page will scroll to initial calculated position of the target element
                window.scroll({
                    top: calculatedTop,
                    left: left,
                    behavior: "smooth"
                });

                // While the page scrolls, images will load in which will push the target element further down the page
                // This setInterval will recalculate for the target element's position until the page finally scrolls to the correct position
                var intervalId = setInterval(function () {
                    boundingClientRect = element.getBoundingClientRect();
                    calculatedTop = boundingClientRect.top + window.scrollY - offset;

                    if (currentTop !== calculatedTop) {
                        window.scroll({
                            top: calculatedTop,
                            left: left,
                            behavior: "smooth"
                        });

                        currentTop = calculatedTop;
                    }
                    else if (currentTop === calculatedTop) { // When the correct position for the target element is finally reached, this interval will be cleared
                        clearInterval(intervalId);
                    }
                }, 500);
            }
        }

        event.stopPropagation();
    }

    this.handleChangedOwlCarousel = function (scope, event) {
        if (event.property && event.property.name == 'position') { // Only listen to the position changed event

            // Only attempt screen-reader work when an owl nav button is actually
            // focused (keyboard navigation). During touch swipes, $(':focus') can return
            // a form input from the previous slide � detaching that mid-gesture causes
            // the layout reflows and body-visibility glitches
            var $focusedElement = $(':focus');
            var isNavButtonFocused = $focusedElement.length > 0
                && ($focusedElement.hasClass('owl-next') || $focusedElement.hasClass('owl-prev'));

            if (isNavButtonFocused) {
                // Safely force screen reader to re-read the button by briefly toggling
                // the .sr-only text inside it. This achieves the same re-announcement
                // effect as the old detach()/reattach pattern without any DOM removal.
                var $srSpan = $focusedElement.find('.sr-only');
                var originalText = $srSpan.text();

                $srSpan.text('\u00A0');
                setTimeout(function () {
                    $srSpan.text(originalText);
                    $focusedElement.trigger('focus');
                }, 100);
            }

            if (!scope.slidesAreLoaded) {

                var items = scope.$element.find('.owl-item');
                items.each(function () {
                    var $element = $(this);
                    $responsiveImg = $element.find('img.u-responsiveMedia');

                    // Cloned items are not in DOM at page load and not processed by responsive media
                    if ($element.hasClass('cloned')) {
                        $responsiveImg.attach(ResponsiveMedia);
                    }

                    $responsiveImg.trigger("RESPONSIVE_LAZYLOAD");

                    // Avoid applying inline display: block to images within .no-display-block containers
                    if ($responsiveImg.closest('.no-display-block').length === 0) {
                        $responsiveImg.on('load', function () {
                            $element.css('display', 'block');
                        });
                    }
                });

                if (items.length > 0) {
                    scope.$element.cloudinary_update();
                    $.cloudinary.responsive();
                    scope.slidesAreLoaded = true;
                }
            }
        }
    }

    this.initializeLeadForm = function ($element) {
        var $phoneInputs = $element.find('input[name="Phone"]');
        if ($phoneInputs && $phoneInputs.length) {
            for (var index = 0; index < $phoneInputs.length; index++) {
                var phoneInput = $phoneInputs[index];
                $(phoneInput).on('input keyup change', this.formatPhoneNumber.bind(this));
            }
        }
    }

    this.updateSelectableItems = function ($carousel) {
        // Natively focusable/interactive controls that can appear inside a slide.
        //  - Excludes input[type="hidden"] (e.g. the anti-forgery token in Save buttons): hidden
        //    inputs are never focusable, so applying tabindex to them is invalid.
        //  - Includes iframe (YouTube video slides), select and textarea so inactive slides are fully
        //    removed from the tab order. aria-hidden does NOT stop keyboard focus reaching them, so
        //    without this a user could still Tab into an off-screen/inactive video iframe.
        var nativelyFocusableSelector = 'a[href], button, input:not([type="hidden"]), select, textarea, iframe';
        // The full set also includes non-native controls that are only keyboard-reachable via tabindex
        // (the hrefless deeplink CTA anchor, .submit-button, .icon-close).
        var focusableSelector = nativelyFocusableSelector + ', a, .submit-button, .icon-close';

        // Hide every inactive slide (and its focusable controls) from assistive tech and
        // remove those controls from the tab order.
        var $inactiveItems = $carousel.find('.owl-item:not(.active)');
        $inactiveItems.attr('aria-hidden', true);
        $inactiveItems.find(focusableSelector).attr({ 'tabindex': -1, 'aria-hidden': true });

        // Expose the active slide(s) to assistive tech.
        var $activeItems = $carousel.find('.owl-item.active');
        $activeItems.attr('aria-hidden', false);

        // set active owl-item elements to selectable
        var $activeOwlItem = $carousel.find('.owl-item.active');
        var activeOwlItemClickableItems = $activeOwlItem.find('a, button, input, .submit-button, .icon-close');
        if (activeOwlItemClickableItems && activeOwlItemClickableItems.length > 0) {
            activeOwlItemClickableItems.attr({ 'aria-hidden': false }).removeAttr('tabindex');
        }
    }

    // Helpers
    this.formatPhoneNumber = function (event) {
        var phoneInput = event.target;
        if (phoneInput) {
            $(phoneInput).val(utils.formatDirtyPhoneNumber($(phoneInput).val()));
        }
    }

    this.disableSingleImageCarouselSwipe = function () {
        // Single Image Carousels have 5 cloned items
        var isSingleImageCarousel = component.find('.owl-item').length === 5;
        if (isSingleImageCarousel) {
            component.find('.owl-stage').css({ 'pointer-events': 'none', 'cursor': 'pointer' });
            component.find('.Social-btn, .Share-icon').css('pointer-events', 'all');
        }
    }
}

module.exports = component(CarouselV2);
